var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"helpscroll",class:[_vm.bgColor, 'section-container', 'font-family'],attrs:{"bg-color":"bg-white","tabindex":"-1","id":"help-top"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }